import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { IGoogleMapsMarker } from '@app/interfaces/IGoogleMapsMarkerOptions';
import { IJourney } from '@app/interfaces/IJourney';
import { IPlot } from '@app/interfaces/IPlot';

@Directive({
    selector: 'veri-map-container'
})
export class VeriMapContainerComponentFacade extends UpgradeComponent {
    @Input() hideGeofences: boolean;
    @Input() journeys: IJourney[];
    @Input() plots: IPlot[];
    @Input() selectedPlot: IPlot;
    @Input() locationMarker: IGoogleMapsMarker;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('veriMapContainer', elementRef, injector);
    }
}
